fragment PeepRelatedLeadFragment on Lead {
    id
    htmlUrl
    name
    number
    value {
        formatted
    }
    status
    avatarUrl
    contacts {
        primaryEdge {
            node {
                id
                htmlUrl
                name
            }
        }
    }
    accounts {
        primaryEdge {
            node {
                id
                htmlUrl
                name
            }
        }
    }
    assignee {
        id
        name
    }
}
